import { Icon } from "./Icon.js";

export const BrandMark = (): React.JSX.Element => (
  <span className="brand-mark" aria-hidden="true">
    <Icon name="scale" size={16} />
  </span>
);
